export default "__VITE_ASSET__de1a1859__"